// source: eshop/Basket.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.eshop.BasketError', null, global);
goog.exportSymbol('proto.eshop.BasketError.Code', null, global);
goog.exportSymbol('proto.eshop.CustomerSurvey', null, global);
goog.exportSymbol('proto.eshop.DeliveryInfo', null, global);
goog.exportSymbol('proto.eshop.DeliveryOption', null, global);
goog.exportSymbol('proto.eshop.DeliveryPrice', null, global);
goog.exportSymbol('proto.eshop.DeliveryType', null, global);
goog.exportSymbol('proto.eshop.DigitalProductInfoReply', null, global);
goog.exportSymbol('proto.eshop.DigitalProductInfoReply.ResultCase', null, global);
goog.exportSymbol('proto.eshop.DigitalProductInfoRequest', null, global);
goog.exportSymbol('proto.eshop.Discount', null, global);
goog.exportSymbol('proto.eshop.Discount.Target', null, global);
goog.exportSymbol('proto.eshop.Discount.ValueCase', null, global);
goog.exportSymbol('proto.eshop.DiscountInfo', null, global);
goog.exportSymbol('proto.eshop.EShopConfig', null, global);
goog.exportSymbol('proto.eshop.Juridical', null, global);
goog.exportSymbol('proto.eshop.Lang', null, global);
goog.exportSymbol('proto.eshop.OrderInfo', null, global);
goog.exportSymbol('proto.eshop.OrderItem', null, global);
goog.exportSymbol('proto.eshop.OrderSummaryReply', null, global);
goog.exportSymbol('proto.eshop.OrderSummaryRequest', null, global);
goog.exportSymbol('proto.eshop.PaymentGateway', null, global);
goog.exportSymbol('proto.eshop.PaymentOption', null, global);
goog.exportSymbol('proto.eshop.PaymentState', null, global);
goog.exportSymbol('proto.eshop.PlaceOrderOk', null, global);
goog.exportSymbol('proto.eshop.PlaceOrderOk.ResultCase', null, global);
goog.exportSymbol('proto.eshop.PlaceOrderReply', null, global);
goog.exportSymbol('proto.eshop.PlaceOrderReply.ResultCase', null, global);
goog.exportSymbol('proto.eshop.PlaceOrderRequest', null, global);
goog.exportSymbol('proto.eshop.ProductInfoOk', null, global);
goog.exportSymbol('proto.eshop.ProductInfoOk.Type', null, global);
goog.exportSymbol('proto.eshop.ProductInfoReply', null, global);
goog.exportSymbol('proto.eshop.ProductInfoReply.ResultCase', null, global);
goog.exportSymbol('proto.eshop.ProductInfoRequest', null, global);
goog.exportSymbol('proto.eshop.PurchasePosition', null, global);
goog.exportSymbol('proto.eshop.SalesContact', null, global);
goog.exportSymbol('proto.eshop.SalesContactType', null, global);
goog.exportSymbol('proto.eshop.SalesContacts', null, global);
goog.exportSymbol('proto.eshop.SurveyField', null, global);
goog.exportSymbol('proto.eshop.ValidateDiscountReply', null, global);
goog.exportSymbol('proto.eshop.ValidateDiscountReply.ResultCase', null, global);
goog.exportSymbol('proto.eshop.ValidateDiscountRequest', null, global);
goog.exportSymbol('proto.eshop.ValidateEmailReply', null, global);
goog.exportSymbol('proto.eshop.ValidateEmailRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.BasketError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.BasketError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.BasketError.displayName = 'proto.eshop.BasketError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ProductInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.ProductInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ProductInfoRequest.displayName = 'proto.eshop.ProductInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ProductInfoOk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.ProductInfoOk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ProductInfoOk.displayName = 'proto.eshop.ProductInfoOk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ProductInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.eshop.ProductInfoReply.oneofGroups_);
};
goog.inherits(proto.eshop.ProductInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ProductInfoReply.displayName = 'proto.eshop.ProductInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.DigitalProductInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.DigitalProductInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.DigitalProductInfoRequest.displayName = 'proto.eshop.DigitalProductInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.DigitalProductInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.eshop.DigitalProductInfoReply.oneofGroups_);
};
goog.inherits(proto.eshop.DigitalProductInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.DigitalProductInfoReply.displayName = 'proto.eshop.DigitalProductInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.PaymentOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.PaymentOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.PaymentOption.displayName = 'proto.eshop.PaymentOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.DeliveryPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.DeliveryPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.DeliveryPrice.displayName = 'proto.eshop.DeliveryPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.DeliveryOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eshop.DeliveryOption.repeatedFields_, null);
};
goog.inherits(proto.eshop.DeliveryOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.DeliveryOption.displayName = 'proto.eshop.DeliveryOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.PurchasePosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.PurchasePosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.PurchasePosition.displayName = 'proto.eshop.PurchasePosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.CustomerSurvey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.CustomerSurvey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.CustomerSurvey.displayName = 'proto.eshop.CustomerSurvey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.PlaceOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eshop.PlaceOrderRequest.repeatedFields_, null);
};
goog.inherits(proto.eshop.PlaceOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.PlaceOrderRequest.displayName = 'proto.eshop.PlaceOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.PlaceOrderOk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.eshop.PlaceOrderOk.oneofGroups_);
};
goog.inherits(proto.eshop.PlaceOrderOk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.PlaceOrderOk.displayName = 'proto.eshop.PlaceOrderOk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.PlaceOrderReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.eshop.PlaceOrderReply.oneofGroups_);
};
goog.inherits(proto.eshop.PlaceOrderReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.PlaceOrderReply.displayName = 'proto.eshop.PlaceOrderReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.OrderSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.OrderSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.OrderSummaryRequest.displayName = 'proto.eshop.OrderSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.OrderSummaryReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.OrderSummaryReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.OrderSummaryReply.displayName = 'proto.eshop.OrderSummaryReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.Juridical = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.Juridical, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.Juridical.displayName = 'proto.eshop.Juridical';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.OrderItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.OrderItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.OrderItem.displayName = 'proto.eshop.OrderItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.DiscountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.DiscountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.DiscountInfo.displayName = 'proto.eshop.DiscountInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.DeliveryInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.DeliveryInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.DeliveryInfo.displayName = 'proto.eshop.DeliveryInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.OrderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eshop.OrderInfo.repeatedFields_, null);
};
goog.inherits(proto.eshop.OrderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.OrderInfo.displayName = 'proto.eshop.OrderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.SalesContact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.SalesContact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.SalesContact.displayName = 'proto.eshop.SalesContact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.SalesContacts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eshop.SalesContacts.repeatedFields_, null);
};
goog.inherits(proto.eshop.SalesContacts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.SalesContacts.displayName = 'proto.eshop.SalesContacts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.EShopConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eshop.EShopConfig.repeatedFields_, null);
};
goog.inherits(proto.eshop.EShopConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.EShopConfig.displayName = 'proto.eshop.EShopConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ValidateEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.ValidateEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ValidateEmailRequest.displayName = 'proto.eshop.ValidateEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ValidateEmailReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.ValidateEmailReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ValidateEmailReply.displayName = 'proto.eshop.ValidateEmailReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ValidateDiscountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eshop.ValidateDiscountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ValidateDiscountRequest.displayName = 'proto.eshop.ValidateDiscountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.Discount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eshop.Discount.repeatedFields_, proto.eshop.Discount.oneofGroups_);
};
goog.inherits(proto.eshop.Discount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.Discount.displayName = 'proto.eshop.Discount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eshop.ValidateDiscountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.eshop.ValidateDiscountReply.oneofGroups_);
};
goog.inherits(proto.eshop.ValidateDiscountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eshop.ValidateDiscountReply.displayName = 'proto.eshop.ValidateDiscountReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.BasketError.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.BasketError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.BasketError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.BasketError.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    num: jspb.Message.getFieldWithDefault(msg, 2, 0),
    requestId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.BasketError}
 */
proto.eshop.BasketError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.BasketError;
  return proto.eshop.BasketError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.BasketError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.BasketError}
 */
proto.eshop.BasketError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.eshop.BasketError.Code} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNum(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.BasketError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.BasketError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.BasketError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.BasketError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.eshop.BasketError.Code = {
  NO_CODE: 0,
  INTERNAL: 10,
  BAD_REQUEST: 11,
  FRONTEND_OUT_OF_DATE: 12,
  NOT_FOUND: 101,
  PAYMENT_GATEWAY_UNAVAILABLE: 201
};

/**
 * optional Code code = 1;
 * @return {!proto.eshop.BasketError.Code}
 */
proto.eshop.BasketError.prototype.getCode = function() {
  return /** @type {!proto.eshop.BasketError.Code} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.eshop.BasketError.Code} value
 * @return {!proto.eshop.BasketError} returns this
 */
proto.eshop.BasketError.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 num = 2;
 * @return {number}
 */
proto.eshop.BasketError.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.BasketError} returns this
 */
proto.eshop.BasketError.prototype.setNum = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string request_id = 3;
 * @return {string}
 */
proto.eshop.BasketError.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.BasketError} returns this
 */
proto.eshop.BasketError.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ProductInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ProductInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ProductInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ProductInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    saleRegion: jspb.Message.getFieldWithDefault(msg, 1, ""),
    authSid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ProductInfoRequest}
 */
proto.eshop.ProductInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ProductInfoRequest;
  return proto.eshop.ProductInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ProductInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ProductInfoRequest}
 */
proto.eshop.ProductInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthSid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ProductInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ProductInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ProductInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ProductInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSaleRegion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthSid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string sale_region = 1;
 * @return {string}
 */
proto.eshop.ProductInfoRequest.prototype.getSaleRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoRequest} returns this
 */
proto.eshop.ProductInfoRequest.prototype.setSaleRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string auth_sid = 2;
 * @return {string}
 */
proto.eshop.ProductInfoRequest.prototype.getAuthSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoRequest} returns this
 */
proto.eshop.ProductInfoRequest.prototype.setAuthSid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.eshop.ProductInfoRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoRequest} returns this
 */
proto.eshop.ProductInfoRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ProductInfoOk.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ProductInfoOk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ProductInfoOk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ProductInfoOk.toObject = function(includeInstance, msg) {
  var f, obj = {
    pictureUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    price100: jspb.Message.getFieldWithDefault(msg, 3, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    id: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ProductInfoOk}
 */
proto.eshop.ProductInfoOk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ProductInfoOk;
  return proto.eshop.ProductInfoOk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ProductInfoOk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ProductInfoOk}
 */
proto.eshop.ProductInfoOk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictureUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice100(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 9:
      var value = /** @type {!proto.eshop.ProductInfoOk.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ProductInfoOk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ProductInfoOk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ProductInfoOk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ProductInfoOk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrice100();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.eshop.ProductInfoOk.Type = {
  NO_TYPE: 0,
  MDSE: 1,
  DSP: 2
};

/**
 * optional string picture_url = 1;
 * @return {string}
 */
proto.eshop.ProductInfoOk.prototype.getPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoOk} returns this
 */
proto.eshop.ProductInfoOk.prototype.setPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.eshop.ProductInfoOk.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoOk} returns this
 */
proto.eshop.ProductInfoOk.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 price100 = 3;
 * @return {number}
 */
proto.eshop.ProductInfoOk.prototype.getPrice100 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.ProductInfoOk} returns this
 */
proto.eshop.ProductInfoOk.prototype.setPrice100 = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.eshop.ProductInfoOk.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoOk} returns this
 */
proto.eshop.ProductInfoOk.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string id = 6;
 * @return {string}
 */
proto.eshop.ProductInfoOk.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ProductInfoOk} returns this
 */
proto.eshop.ProductInfoOk.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Type type = 9;
 * @return {!proto.eshop.ProductInfoOk.Type}
 */
proto.eshop.ProductInfoOk.prototype.getType = function() {
  return /** @type {!proto.eshop.ProductInfoOk.Type} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.eshop.ProductInfoOk.Type} value
 * @return {!proto.eshop.ProductInfoOk} returns this
 */
proto.eshop.ProductInfoOk.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eshop.ProductInfoReply.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.eshop.ProductInfoReply.ResultCase = {
  RESULT_NOT_SET: 0,
  OK: 1,
  ERROR: 2
};

/**
 * @return {proto.eshop.ProductInfoReply.ResultCase}
 */
proto.eshop.ProductInfoReply.prototype.getResultCase = function() {
  return /** @type {proto.eshop.ProductInfoReply.ResultCase} */(jspb.Message.computeOneofCase(this, proto.eshop.ProductInfoReply.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ProductInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ProductInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ProductInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ProductInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    ok: (f = msg.getOk()) && proto.eshop.ProductInfoOk.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.eshop.BasketError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ProductInfoReply}
 */
proto.eshop.ProductInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ProductInfoReply;
  return proto.eshop.ProductInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ProductInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ProductInfoReply}
 */
proto.eshop.ProductInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eshop.ProductInfoOk;
      reader.readMessage(value,proto.eshop.ProductInfoOk.deserializeBinaryFromReader);
      msg.setOk(value);
      break;
    case 2:
      var value = new proto.eshop.BasketError;
      reader.readMessage(value,proto.eshop.BasketError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ProductInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ProductInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ProductInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ProductInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOk();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.eshop.ProductInfoOk.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.eshop.BasketError.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProductInfoOk ok = 1;
 * @return {?proto.eshop.ProductInfoOk}
 */
proto.eshop.ProductInfoReply.prototype.getOk = function() {
  return /** @type{?proto.eshop.ProductInfoOk} */ (
    jspb.Message.getWrapperField(this, proto.eshop.ProductInfoOk, 1));
};


/**
 * @param {?proto.eshop.ProductInfoOk|undefined} value
 * @return {!proto.eshop.ProductInfoReply} returns this
*/
proto.eshop.ProductInfoReply.prototype.setOk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.eshop.ProductInfoReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.ProductInfoReply} returns this
 */
proto.eshop.ProductInfoReply.prototype.clearOk = function() {
  return this.setOk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.ProductInfoReply.prototype.hasOk = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BasketError error = 2;
 * @return {?proto.eshop.BasketError}
 */
proto.eshop.ProductInfoReply.prototype.getError = function() {
  return /** @type{?proto.eshop.BasketError} */ (
    jspb.Message.getWrapperField(this, proto.eshop.BasketError, 2));
};


/**
 * @param {?proto.eshop.BasketError|undefined} value
 * @return {!proto.eshop.ProductInfoReply} returns this
*/
proto.eshop.ProductInfoReply.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.eshop.ProductInfoReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.ProductInfoReply} returns this
 */
proto.eshop.ProductInfoReply.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.ProductInfoReply.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.DigitalProductInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.DigitalProductInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.DigitalProductInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DigitalProductInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    saleRegion: jspb.Message.getFieldWithDefault(msg, 1, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.DigitalProductInfoRequest}
 */
proto.eshop.DigitalProductInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.DigitalProductInfoRequest;
  return proto.eshop.DigitalProductInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.DigitalProductInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.DigitalProductInfoRequest}
 */
proto.eshop.DigitalProductInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleRegion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.DigitalProductInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.DigitalProductInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.DigitalProductInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DigitalProductInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSaleRegion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string sale_region = 1;
 * @return {string}
 */
proto.eshop.DigitalProductInfoRequest.prototype.getSaleRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.DigitalProductInfoRequest} returns this
 */
proto.eshop.DigitalProductInfoRequest.prototype.setSaleRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.eshop.DigitalProductInfoRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.DigitalProductInfoRequest} returns this
 */
proto.eshop.DigitalProductInfoRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eshop.DigitalProductInfoReply.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.eshop.DigitalProductInfoReply.ResultCase = {
  RESULT_NOT_SET: 0,
  OK: 1,
  ERROR: 2
};

/**
 * @return {proto.eshop.DigitalProductInfoReply.ResultCase}
 */
proto.eshop.DigitalProductInfoReply.prototype.getResultCase = function() {
  return /** @type {proto.eshop.DigitalProductInfoReply.ResultCase} */(jspb.Message.computeOneofCase(this, proto.eshop.DigitalProductInfoReply.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.DigitalProductInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.DigitalProductInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.DigitalProductInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DigitalProductInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    ok: (f = msg.getOk()) && proto.eshop.ProductInfoOk.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.eshop.BasketError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.DigitalProductInfoReply}
 */
proto.eshop.DigitalProductInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.DigitalProductInfoReply;
  return proto.eshop.DigitalProductInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.DigitalProductInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.DigitalProductInfoReply}
 */
proto.eshop.DigitalProductInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eshop.ProductInfoOk;
      reader.readMessage(value,proto.eshop.ProductInfoOk.deserializeBinaryFromReader);
      msg.setOk(value);
      break;
    case 2:
      var value = new proto.eshop.BasketError;
      reader.readMessage(value,proto.eshop.BasketError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.DigitalProductInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.DigitalProductInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.DigitalProductInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DigitalProductInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOk();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.eshop.ProductInfoOk.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.eshop.BasketError.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProductInfoOk ok = 1;
 * @return {?proto.eshop.ProductInfoOk}
 */
proto.eshop.DigitalProductInfoReply.prototype.getOk = function() {
  return /** @type{?proto.eshop.ProductInfoOk} */ (
    jspb.Message.getWrapperField(this, proto.eshop.ProductInfoOk, 1));
};


/**
 * @param {?proto.eshop.ProductInfoOk|undefined} value
 * @return {!proto.eshop.DigitalProductInfoReply} returns this
*/
proto.eshop.DigitalProductInfoReply.prototype.setOk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.eshop.DigitalProductInfoReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.DigitalProductInfoReply} returns this
 */
proto.eshop.DigitalProductInfoReply.prototype.clearOk = function() {
  return this.setOk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.DigitalProductInfoReply.prototype.hasOk = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BasketError error = 2;
 * @return {?proto.eshop.BasketError}
 */
proto.eshop.DigitalProductInfoReply.prototype.getError = function() {
  return /** @type{?proto.eshop.BasketError} */ (
    jspb.Message.getWrapperField(this, proto.eshop.BasketError, 2));
};


/**
 * @param {?proto.eshop.BasketError|undefined} value
 * @return {!proto.eshop.DigitalProductInfoReply} returns this
*/
proto.eshop.DigitalProductInfoReply.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.eshop.DigitalProductInfoReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.DigitalProductInfoReply} returns this
 */
proto.eshop.DigitalProductInfoReply.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.DigitalProductInfoReply.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.PaymentOption.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.PaymentOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.PaymentOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PaymentOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGateway: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.PaymentOption}
 */
proto.eshop.PaymentOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.PaymentOption;
  return proto.eshop.PaymentOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.PaymentOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.PaymentOption}
 */
proto.eshop.PaymentOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.eshop.PaymentGateway} */ (reader.readEnum());
      msg.setPaymentGateway(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.PaymentOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.PaymentOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.PaymentOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PaymentOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGateway();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional PaymentGateway payment_gateway = 1;
 * @return {!proto.eshop.PaymentGateway}
 */
proto.eshop.PaymentOption.prototype.getPaymentGateway = function() {
  return /** @type {!proto.eshop.PaymentGateway} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.eshop.PaymentGateway} value
 * @return {!proto.eshop.PaymentOption} returns this
 */
proto.eshop.PaymentOption.prototype.setPaymentGateway = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.eshop.PaymentOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PaymentOption} returns this
 */
proto.eshop.PaymentOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.DeliveryPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.DeliveryPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.DeliveryPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DeliveryPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    price100: jspb.Message.getFieldWithDefault(msg, 1, 0),
    paymentGateway: jspb.Message.getFieldWithDefault(msg, 2, 0),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0),
    productId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.DeliveryPrice}
 */
proto.eshop.DeliveryPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.DeliveryPrice;
  return proto.eshop.DeliveryPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.DeliveryPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.DeliveryPrice}
 */
proto.eshop.DeliveryPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice100(value);
      break;
    case 2:
      var value = /** @type {!proto.eshop.PaymentGateway} */ (reader.readEnum());
      msg.setPaymentGateway(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.DeliveryPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.DeliveryPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.DeliveryPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DeliveryPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice100();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPaymentGateway();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 price100 = 1;
 * @return {number}
 */
proto.eshop.DeliveryPrice.prototype.getPrice100 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.DeliveryPrice} returns this
 */
proto.eshop.DeliveryPrice.prototype.setPrice100 = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PaymentGateway payment_gateway = 2;
 * @return {!proto.eshop.PaymentGateway}
 */
proto.eshop.DeliveryPrice.prototype.getPaymentGateway = function() {
  return /** @type {!proto.eshop.PaymentGateway} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.eshop.PaymentGateway} value
 * @return {!proto.eshop.DeliveryPrice} returns this
 */
proto.eshop.DeliveryPrice.prototype.setPaymentGateway = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.eshop.DeliveryPrice.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.DeliveryPrice} returns this
 */
proto.eshop.DeliveryPrice.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string product_id = 4;
 * @return {string}
 */
proto.eshop.DeliveryPrice.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.DeliveryPrice} returns this
 */
proto.eshop.DeliveryPrice.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eshop.DeliveryOption.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.DeliveryOption.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.DeliveryOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.DeliveryOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DeliveryOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.eshop.DeliveryPrice.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.DeliveryOption}
 */
proto.eshop.DeliveryOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.DeliveryOption;
  return proto.eshop.DeliveryOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.DeliveryOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.DeliveryOption}
 */
proto.eshop.DeliveryOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.eshop.DeliveryPrice;
      reader.readMessage(value,proto.eshop.DeliveryPrice.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.DeliveryOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.DeliveryOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.DeliveryOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DeliveryOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.eshop.DeliveryPrice.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.eshop.DeliveryOption.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.DeliveryOption} returns this
 */
proto.eshop.DeliveryOption.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.eshop.DeliveryOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.DeliveryOption} returns this
 */
proto.eshop.DeliveryOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DeliveryPrice prices = 3;
 * @return {!Array<!proto.eshop.DeliveryPrice>}
 */
proto.eshop.DeliveryOption.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.eshop.DeliveryPrice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eshop.DeliveryPrice, 3));
};


/**
 * @param {!Array<!proto.eshop.DeliveryPrice>} value
 * @return {!proto.eshop.DeliveryOption} returns this
*/
proto.eshop.DeliveryOption.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.eshop.DeliveryPrice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eshop.DeliveryPrice}
 */
proto.eshop.DeliveryOption.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.eshop.DeliveryPrice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.DeliveryOption} returns this
 */
proto.eshop.DeliveryOption.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.PurchasePosition.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.PurchasePosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.PurchasePosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PurchasePosition.toObject = function(includeInstance, msg) {
  var f, obj = {
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.PurchasePosition}
 */
proto.eshop.PurchasePosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.PurchasePosition;
  return proto.eshop.PurchasePosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.PurchasePosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.PurchasePosition}
 */
proto.eshop.PurchasePosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.PurchasePosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.PurchasePosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.PurchasePosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PurchasePosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.eshop.PurchasePosition.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PurchasePosition} returns this
 */
proto.eshop.PurchasePosition.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 count = 2;
 * @return {number}
 */
proto.eshop.PurchasePosition.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.PurchasePosition} returns this
 */
proto.eshop.PurchasePosition.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.CustomerSurvey.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.CustomerSurvey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.CustomerSurvey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.CustomerSurvey.toObject = function(includeInstance, msg) {
  var f, obj = {
    fio: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    postcode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    city: jspb.Message.getFieldWithDefault(msg, 5, ""),
    address: jspb.Message.getFieldWithDefault(msg, 6, ""),
    acceptMarketingMessages: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    dntSendTo3rdParties: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.CustomerSurvey}
 */
proto.eshop.CustomerSurvey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.CustomerSurvey;
  return proto.eshop.CustomerSurvey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.CustomerSurvey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.CustomerSurvey}
 */
proto.eshop.CustomerSurvey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFio(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAcceptMarketingMessages(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDntSendTo3rdParties(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.CustomerSurvey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.CustomerSurvey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.CustomerSurvey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.CustomerSurvey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFio();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPostcode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAcceptMarketingMessages();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getDntSendTo3rdParties();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string fio = 1;
 * @return {string}
 */
proto.eshop.CustomerSurvey.prototype.getFio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setFio = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.eshop.CustomerSurvey.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.eshop.CustomerSurvey.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string postcode = 4;
 * @return {string}
 */
proto.eshop.CustomerSurvey.prototype.getPostcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setPostcode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.eshop.CustomerSurvey.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string address = 6;
 * @return {string}
 */
proto.eshop.CustomerSurvey.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool accept_marketing_messages = 7;
 * @return {boolean}
 */
proto.eshop.CustomerSurvey.prototype.getAcceptMarketingMessages = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setAcceptMarketingMessages = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool dnt_send_to_3rd_parties = 8;
 * @return {boolean}
 */
proto.eshop.CustomerSurvey.prototype.getDntSendTo3rdParties = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.CustomerSurvey} returns this
 */
proto.eshop.CustomerSurvey.prototype.setDntSendTo3rdParties = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eshop.PlaceOrderRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.PlaceOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.PlaceOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.PlaceOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PlaceOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    saleRegion: jspb.Message.getFieldWithDefault(msg, 1, ""),
    authSid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    purchaseList: jspb.Message.toObjectList(msg.getPurchaseList(),
    proto.eshop.PurchasePosition.toObject, includeInstance),
    survey: (f = msg.getSurvey()) && proto.eshop.CustomerSurvey.toObject(includeInstance, f),
    paymentGateway: jspb.Message.getFieldWithDefault(msg, 5, 0),
    deliveryId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    deliveryPrice100: jspb.Message.getFieldWithDefault(msg, 8, 0),
    promoCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    dsUserToken: jspb.Message.getFieldWithDefault(msg, 10, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 55, ""),
    domain: jspb.Message.getFieldWithDefault(msg, 99, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.PlaceOrderRequest}
 */
proto.eshop.PlaceOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.PlaceOrderRequest;
  return proto.eshop.PlaceOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.PlaceOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.PlaceOrderRequest}
 */
proto.eshop.PlaceOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthSid(value);
      break;
    case 3:
      var value = new proto.eshop.PurchasePosition;
      reader.readMessage(value,proto.eshop.PurchasePosition.deserializeBinaryFromReader);
      msg.addPurchase(value);
      break;
    case 4:
      var value = new proto.eshop.CustomerSurvey;
      reader.readMessage(value,proto.eshop.CustomerSurvey.deserializeBinaryFromReader);
      msg.setSurvey(value);
      break;
    case 5:
      var value = /** @type {!proto.eshop.PaymentGateway} */ (reader.readEnum());
      msg.setPaymentGateway(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeliveryId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeliveryPrice100(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromoCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDsUserToken(value);
      break;
    case 55:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 99:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.PlaceOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.PlaceOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.PlaceOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PlaceOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSaleRegion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthSid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPurchaseList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.eshop.PurchasePosition.serializeBinaryToWriter
    );
  }
  f = message.getSurvey();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.eshop.CustomerSurvey.serializeBinaryToWriter
    );
  }
  f = message.getPaymentGateway();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDeliveryId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getDeliveryPrice100();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPromoCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDsUserToken();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      55,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      99,
      f
    );
  }
};


/**
 * optional string sale_region = 1;
 * @return {string}
 */
proto.eshop.PlaceOrderRequest.prototype.getSaleRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setSaleRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string auth_sid = 2;
 * @return {string}
 */
proto.eshop.PlaceOrderRequest.prototype.getAuthSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setAuthSid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PurchasePosition purchase = 3;
 * @return {!Array<!proto.eshop.PurchasePosition>}
 */
proto.eshop.PlaceOrderRequest.prototype.getPurchaseList = function() {
  return /** @type{!Array<!proto.eshop.PurchasePosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eshop.PurchasePosition, 3));
};


/**
 * @param {!Array<!proto.eshop.PurchasePosition>} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
*/
proto.eshop.PlaceOrderRequest.prototype.setPurchaseList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.eshop.PurchasePosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eshop.PurchasePosition}
 */
proto.eshop.PlaceOrderRequest.prototype.addPurchase = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.eshop.PurchasePosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.clearPurchaseList = function() {
  return this.setPurchaseList([]);
};


/**
 * optional CustomerSurvey survey = 4;
 * @return {?proto.eshop.CustomerSurvey}
 */
proto.eshop.PlaceOrderRequest.prototype.getSurvey = function() {
  return /** @type{?proto.eshop.CustomerSurvey} */ (
    jspb.Message.getWrapperField(this, proto.eshop.CustomerSurvey, 4));
};


/**
 * @param {?proto.eshop.CustomerSurvey|undefined} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
*/
proto.eshop.PlaceOrderRequest.prototype.setSurvey = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.clearSurvey = function() {
  return this.setSurvey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.PlaceOrderRequest.prototype.hasSurvey = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PaymentGateway payment_gateway = 5;
 * @return {!proto.eshop.PaymentGateway}
 */
proto.eshop.PlaceOrderRequest.prototype.getPaymentGateway = function() {
  return /** @type {!proto.eshop.PaymentGateway} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.eshop.PaymentGateway} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setPaymentGateway = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 delivery_id = 7;
 * @return {number}
 */
proto.eshop.PlaceOrderRequest.prototype.getDeliveryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setDeliveryId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 delivery_price100 = 8;
 * @return {number}
 */
proto.eshop.PlaceOrderRequest.prototype.getDeliveryPrice100 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setDeliveryPrice100 = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string promo_code = 9;
 * @return {string}
 */
proto.eshop.PlaceOrderRequest.prototype.getPromoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setPromoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string ds_user_token = 10;
 * @return {string}
 */
proto.eshop.PlaceOrderRequest.prototype.getDsUserToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setDsUserToken = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string comment = 55;
 * @return {string}
 */
proto.eshop.PlaceOrderRequest.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 55, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 55, value);
};


/**
 * optional string domain = 99;
 * @return {string}
 */
proto.eshop.PlaceOrderRequest.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 99, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderRequest} returns this
 */
proto.eshop.PlaceOrderRequest.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 99, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eshop.PlaceOrderOk.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.eshop.PlaceOrderOk.ResultCase = {
  RESULT_NOT_SET: 0,
  REDIRECT_URL: 1,
  HTML_FORM: 2
};

/**
 * @return {proto.eshop.PlaceOrderOk.ResultCase}
 */
proto.eshop.PlaceOrderOk.prototype.getResultCase = function() {
  return /** @type {proto.eshop.PlaceOrderOk.ResultCase} */(jspb.Message.computeOneofCase(this, proto.eshop.PlaceOrderOk.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.PlaceOrderOk.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.PlaceOrderOk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.PlaceOrderOk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PlaceOrderOk.toObject = function(includeInstance, msg) {
  var f, obj = {
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    htmlForm: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.PlaceOrderOk}
 */
proto.eshop.PlaceOrderOk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.PlaceOrderOk;
  return proto.eshop.PlaceOrderOk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.PlaceOrderOk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.PlaceOrderOk}
 */
proto.eshop.PlaceOrderOk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.PlaceOrderOk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.PlaceOrderOk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.PlaceOrderOk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PlaceOrderOk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string redirect_url = 1;
 * @return {string}
 */
proto.eshop.PlaceOrderOk.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderOk} returns this
 */
proto.eshop.PlaceOrderOk.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.eshop.PlaceOrderOk.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eshop.PlaceOrderOk} returns this
 */
proto.eshop.PlaceOrderOk.prototype.clearRedirectUrl = function() {
  return jspb.Message.setOneofField(this, 1, proto.eshop.PlaceOrderOk.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.PlaceOrderOk.prototype.hasRedirectUrl = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string html_form = 2;
 * @return {string}
 */
proto.eshop.PlaceOrderOk.prototype.getHtmlForm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.PlaceOrderOk} returns this
 */
proto.eshop.PlaceOrderOk.prototype.setHtmlForm = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.eshop.PlaceOrderOk.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eshop.PlaceOrderOk} returns this
 */
proto.eshop.PlaceOrderOk.prototype.clearHtmlForm = function() {
  return jspb.Message.setOneofField(this, 2, proto.eshop.PlaceOrderOk.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.PlaceOrderOk.prototype.hasHtmlForm = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eshop.PlaceOrderReply.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.eshop.PlaceOrderReply.ResultCase = {
  RESULT_NOT_SET: 0,
  OK: 1,
  ERROR: 2
};

/**
 * @return {proto.eshop.PlaceOrderReply.ResultCase}
 */
proto.eshop.PlaceOrderReply.prototype.getResultCase = function() {
  return /** @type {proto.eshop.PlaceOrderReply.ResultCase} */(jspb.Message.computeOneofCase(this, proto.eshop.PlaceOrderReply.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.PlaceOrderReply.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.PlaceOrderReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.PlaceOrderReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PlaceOrderReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    ok: (f = msg.getOk()) && proto.eshop.PlaceOrderOk.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.eshop.BasketError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.PlaceOrderReply}
 */
proto.eshop.PlaceOrderReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.PlaceOrderReply;
  return proto.eshop.PlaceOrderReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.PlaceOrderReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.PlaceOrderReply}
 */
proto.eshop.PlaceOrderReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eshop.PlaceOrderOk;
      reader.readMessage(value,proto.eshop.PlaceOrderOk.deserializeBinaryFromReader);
      msg.setOk(value);
      break;
    case 2:
      var value = new proto.eshop.BasketError;
      reader.readMessage(value,proto.eshop.BasketError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.PlaceOrderReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.PlaceOrderReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.PlaceOrderReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.PlaceOrderReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOk();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.eshop.PlaceOrderOk.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.eshop.BasketError.serializeBinaryToWriter
    );
  }
};


/**
 * optional PlaceOrderOk ok = 1;
 * @return {?proto.eshop.PlaceOrderOk}
 */
proto.eshop.PlaceOrderReply.prototype.getOk = function() {
  return /** @type{?proto.eshop.PlaceOrderOk} */ (
    jspb.Message.getWrapperField(this, proto.eshop.PlaceOrderOk, 1));
};


/**
 * @param {?proto.eshop.PlaceOrderOk|undefined} value
 * @return {!proto.eshop.PlaceOrderReply} returns this
*/
proto.eshop.PlaceOrderReply.prototype.setOk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.eshop.PlaceOrderReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.PlaceOrderReply} returns this
 */
proto.eshop.PlaceOrderReply.prototype.clearOk = function() {
  return this.setOk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.PlaceOrderReply.prototype.hasOk = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BasketError error = 2;
 * @return {?proto.eshop.BasketError}
 */
proto.eshop.PlaceOrderReply.prototype.getError = function() {
  return /** @type{?proto.eshop.BasketError} */ (
    jspb.Message.getWrapperField(this, proto.eshop.BasketError, 2));
};


/**
 * @param {?proto.eshop.BasketError|undefined} value
 * @return {!proto.eshop.PlaceOrderReply} returns this
*/
proto.eshop.PlaceOrderReply.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.eshop.PlaceOrderReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.PlaceOrderReply} returns this
 */
proto.eshop.PlaceOrderReply.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.PlaceOrderReply.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.OrderSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.OrderSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.OrderSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.OrderSummaryRequest}
 */
proto.eshop.OrderSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.OrderSummaryRequest;
  return proto.eshop.OrderSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.OrderSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.OrderSummaryRequest}
 */
proto.eshop.OrderSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.OrderSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.OrderSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.OrderSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.eshop.OrderSummaryRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.OrderSummaryRequest} returns this
 */
proto.eshop.OrderSummaryRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.OrderSummaryReply.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.OrderSummaryReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.OrderSummaryReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderSummaryReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentstatus: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.OrderSummaryReply}
 */
proto.eshop.OrderSummaryReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.OrderSummaryReply;
  return proto.eshop.OrderSummaryReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.OrderSummaryReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.OrderSummaryReply}
 */
proto.eshop.OrderSummaryReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.eshop.PaymentState} */ (reader.readEnum());
      msg.setPaymentstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.OrderSummaryReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.OrderSummaryReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.OrderSummaryReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderSummaryReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional PaymentState paymentStatus = 1;
 * @return {!proto.eshop.PaymentState}
 */
proto.eshop.OrderSummaryReply.prototype.getPaymentstatus = function() {
  return /** @type {!proto.eshop.PaymentState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.eshop.PaymentState} value
 * @return {!proto.eshop.OrderSummaryReply} returns this
 */
proto.eshop.OrderSummaryReply.prototype.setPaymentstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.Juridical.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.Juridical.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.Juridical} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.Juridical.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.Juridical}
 */
proto.eshop.Juridical.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.Juridical;
  return proto.eshop.Juridical.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.Juridical} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.Juridical}
 */
proto.eshop.Juridical.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.Juridical.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.Juridical.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.Juridical} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.Juridical.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.eshop.Juridical.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.Juridical} returns this
 */
proto.eshop.Juridical.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.eshop.Juridical.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.Juridical} returns this
 */
proto.eshop.Juridical.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.OrderItem.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.OrderItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.OrderItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    pictureUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    price100: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.OrderItem}
 */
proto.eshop.OrderItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.OrderItem;
  return proto.eshop.OrderItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.OrderItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.OrderItem}
 */
proto.eshop.OrderItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictureUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice100(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.OrderItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.OrderItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.OrderItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrice100();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string picture_url = 1;
 * @return {string}
 */
proto.eshop.OrderItem.prototype.getPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.OrderItem} returns this
 */
proto.eshop.OrderItem.prototype.setPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.eshop.OrderItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.OrderItem} returns this
 */
proto.eshop.OrderItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 count = 3;
 * @return {number}
 */
proto.eshop.OrderItem.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.OrderItem} returns this
 */
proto.eshop.OrderItem.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 price100 = 4;
 * @return {number}
 */
proto.eshop.OrderItem.prototype.getPrice100 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.OrderItem} returns this
 */
proto.eshop.OrderItem.prototype.setPrice100 = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.DiscountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.DiscountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.DiscountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DiscountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.DiscountInfo}
 */
proto.eshop.DiscountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.DiscountInfo;
  return proto.eshop.DiscountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.DiscountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.DiscountInfo}
 */
proto.eshop.DiscountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.DiscountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.DiscountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.DiscountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DiscountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.eshop.DiscountInfo.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.DiscountInfo} returns this
 */
proto.eshop.DiscountInfo.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.DeliveryInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.DeliveryInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.DeliveryInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DeliveryInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price100: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.DeliveryInfo}
 */
proto.eshop.DeliveryInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.DeliveryInfo;
  return proto.eshop.DeliveryInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.DeliveryInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.DeliveryInfo}
 */
proto.eshop.DeliveryInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice100(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.DeliveryInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.DeliveryInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.DeliveryInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.DeliveryInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice100();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.eshop.DeliveryInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.DeliveryInfo} returns this
 */
proto.eshop.DeliveryInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 price100 = 2;
 * @return {number}
 */
proto.eshop.DeliveryInfo.prototype.getPrice100 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.DeliveryInfo} returns this
 */
proto.eshop.DeliveryInfo.prototype.setPrice100 = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eshop.OrderInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.OrderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.OrderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.OrderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentstatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.eshop.OrderItem.toObject, includeInstance),
    delivery: (f = msg.getDelivery()) && proto.eshop.DeliveryInfo.toObject(includeInstance, f),
    num: jspb.Message.getFieldWithDefault(msg, 6, 0),
    discount: (f = msg.getDiscount()) && proto.eshop.DiscountInfo.toObject(includeInstance, f),
    total100: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.OrderInfo}
 */
proto.eshop.OrderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.OrderInfo;
  return proto.eshop.OrderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.OrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.OrderInfo}
 */
proto.eshop.OrderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.eshop.PaymentState} */ (reader.readEnum());
      msg.setPaymentstatus(value);
      break;
    case 4:
      var value = new proto.eshop.OrderItem;
      reader.readMessage(value,proto.eshop.OrderItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 5:
      var value = new proto.eshop.DeliveryInfo;
      reader.readMessage(value,proto.eshop.DeliveryInfo.deserializeBinaryFromReader);
      msg.setDelivery(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNum(value);
      break;
    case 9:
      var value = new proto.eshop.DiscountInfo;
      reader.readMessage(value,proto.eshop.DiscountInfo.deserializeBinaryFromReader);
      msg.setDiscount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal100(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.OrderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.OrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.OrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.OrderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.eshop.OrderItem.serializeBinaryToWriter
    );
  }
  f = message.getDelivery();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.eshop.DeliveryInfo.serializeBinaryToWriter
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getDiscount();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.eshop.DiscountInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotal100();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eshop.OrderInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PaymentState paymentStatus = 2;
 * @return {!proto.eshop.PaymentState}
 */
proto.eshop.OrderInfo.prototype.getPaymentstatus = function() {
  return /** @type {!proto.eshop.PaymentState} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.eshop.PaymentState} value
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.setPaymentstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated OrderItem items = 4;
 * @return {!Array<!proto.eshop.OrderItem>}
 */
proto.eshop.OrderInfo.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.eshop.OrderItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eshop.OrderItem, 4));
};


/**
 * @param {!Array<!proto.eshop.OrderItem>} value
 * @return {!proto.eshop.OrderInfo} returns this
*/
proto.eshop.OrderInfo.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.eshop.OrderItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eshop.OrderItem}
 */
proto.eshop.OrderInfo.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.eshop.OrderItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional DeliveryInfo delivery = 5;
 * @return {?proto.eshop.DeliveryInfo}
 */
proto.eshop.OrderInfo.prototype.getDelivery = function() {
  return /** @type{?proto.eshop.DeliveryInfo} */ (
    jspb.Message.getWrapperField(this, proto.eshop.DeliveryInfo, 5));
};


/**
 * @param {?proto.eshop.DeliveryInfo|undefined} value
 * @return {!proto.eshop.OrderInfo} returns this
*/
proto.eshop.OrderInfo.prototype.setDelivery = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.clearDelivery = function() {
  return this.setDelivery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.OrderInfo.prototype.hasDelivery = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 num = 6;
 * @return {number}
 */
proto.eshop.OrderInfo.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.setNum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional DiscountInfo discount = 9;
 * @return {?proto.eshop.DiscountInfo}
 */
proto.eshop.OrderInfo.prototype.getDiscount = function() {
  return /** @type{?proto.eshop.DiscountInfo} */ (
    jspb.Message.getWrapperField(this, proto.eshop.DiscountInfo, 9));
};


/**
 * @param {?proto.eshop.DiscountInfo|undefined} value
 * @return {!proto.eshop.OrderInfo} returns this
*/
proto.eshop.OrderInfo.prototype.setDiscount = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.clearDiscount = function() {
  return this.setDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.OrderInfo.prototype.hasDiscount = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int32 total100 = 10;
 * @return {number}
 */
proto.eshop.OrderInfo.prototype.getTotal100 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.OrderInfo} returns this
 */
proto.eshop.OrderInfo.prototype.setTotal100 = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.SalesContact.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.SalesContact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.SalesContact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.SalesContact.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.SalesContact}
 */
proto.eshop.SalesContact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.SalesContact;
  return proto.eshop.SalesContact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.SalesContact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.SalesContact}
 */
proto.eshop.SalesContact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.eshop.SalesContactType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.SalesContact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.SalesContact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.SalesContact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.SalesContact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional SalesContactType type = 1;
 * @return {!proto.eshop.SalesContactType}
 */
proto.eshop.SalesContact.prototype.getType = function() {
  return /** @type {!proto.eshop.SalesContactType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.eshop.SalesContactType} value
 * @return {!proto.eshop.SalesContact} returns this
 */
proto.eshop.SalesContact.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.eshop.SalesContact.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.SalesContact} returns this
 */
proto.eshop.SalesContact.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eshop.SalesContacts.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.SalesContacts.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.SalesContacts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.SalesContacts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.SalesContacts.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contactsList: jspb.Message.toObjectList(msg.getContactsList(),
    proto.eshop.SalesContact.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.SalesContacts}
 */
proto.eshop.SalesContacts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.SalesContacts;
  return proto.eshop.SalesContacts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.SalesContacts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.SalesContacts}
 */
proto.eshop.SalesContacts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.eshop.SalesContact;
      reader.readMessage(value,proto.eshop.SalesContact.deserializeBinaryFromReader);
      msg.addContacts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.SalesContacts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.SalesContacts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.SalesContacts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.SalesContacts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.eshop.SalesContact.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.eshop.SalesContacts.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.SalesContacts} returns this
 */
proto.eshop.SalesContacts.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SalesContact contacts = 2;
 * @return {!Array<!proto.eshop.SalesContact>}
 */
proto.eshop.SalesContacts.prototype.getContactsList = function() {
  return /** @type{!Array<!proto.eshop.SalesContact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eshop.SalesContact, 2));
};


/**
 * @param {!Array<!proto.eshop.SalesContact>} value
 * @return {!proto.eshop.SalesContacts} returns this
*/
proto.eshop.SalesContacts.prototype.setContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.eshop.SalesContact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eshop.SalesContact}
 */
proto.eshop.SalesContacts.prototype.addContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.eshop.SalesContact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.SalesContacts} returns this
 */
proto.eshop.SalesContacts.prototype.clearContactsList = function() {
  return this.setContactsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eshop.EShopConfig.repeatedFields_ = [64,65,224,315];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.EShopConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.EShopConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.EShopConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.EShopConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    saleRegion: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lang: jspb.Message.getFieldWithDefault(msg, 20, 0),
    apiUrl: jspb.Message.getFieldWithDefault(msg, 50, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 60, ""),
    vat: jspb.Message.getFloatingPointFieldWithDefault(msg, 62, 0.0),
    paymentOptionsList: jspb.Message.toObjectList(msg.getPaymentOptionsList(),
    proto.eshop.PaymentOption.toObject, includeInstance),
    deliveryOptionsList: jspb.Message.toObjectList(msg.getDeliveryOptionsList(),
    proto.eshop.DeliveryOption.toObject, includeInstance),
    privacyPolicy: (f = msg.getPrivacyPolicy()) && proto.eshop.Juridical.toObject(includeInstance, f),
    acceptMarketingMessages: (f = msg.getAcceptMarketingMessages()) && proto.eshop.Juridical.toObject(includeInstance, f),
    dntSendToThirdParties: (f = msg.getDntSendToThirdParties()) && proto.eshop.Juridical.toObject(includeInstance, f),
    cookiePolicy: jspb.Message.getFieldWithDefault(msg, 89, ""),
    basketLink: jspb.Message.getFieldWithDefault(msg, 90, ""),
    order: (f = msg.getOrder()) && proto.eshop.OrderInfo.toObject(includeInstance, f),
    salesContacts: (f = msg.getSalesContacts()) && proto.eshop.SalesContacts.toObject(includeInstance, f),
    dsUserToken: jspb.Message.getFieldWithDefault(msg, 155, ""),
    promocodesEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 202, false),
    deliveryEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 213, false),
    productCounterEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 219, false),
    surveyFieldsEnabledList: (f = jspb.Message.getRepeatedField(msg, 224)) == null ? undefined : f,
    commentFieldEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 235, false),
    landingScriptsList: (f = jspb.Message.getRepeatedField(msg, 315)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.EShopConfig}
 */
proto.eshop.EShopConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.EShopConfig;
  return proto.eshop.EShopConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.EShopConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.EShopConfig}
 */
proto.eshop.EShopConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleRegion(value);
      break;
    case 20:
      var value = /** @type {!proto.eshop.Lang} */ (reader.readEnum());
      msg.setLang(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiUrl(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setVat(value);
      break;
    case 64:
      var value = new proto.eshop.PaymentOption;
      reader.readMessage(value,proto.eshop.PaymentOption.deserializeBinaryFromReader);
      msg.addPaymentOptions(value);
      break;
    case 65:
      var value = new proto.eshop.DeliveryOption;
      reader.readMessage(value,proto.eshop.DeliveryOption.deserializeBinaryFromReader);
      msg.addDeliveryOptions(value);
      break;
    case 70:
      var value = new proto.eshop.Juridical;
      reader.readMessage(value,proto.eshop.Juridical.deserializeBinaryFromReader);
      msg.setPrivacyPolicy(value);
      break;
    case 80:
      var value = new proto.eshop.Juridical;
      reader.readMessage(value,proto.eshop.Juridical.deserializeBinaryFromReader);
      msg.setAcceptMarketingMessages(value);
      break;
    case 82:
      var value = new proto.eshop.Juridical;
      reader.readMessage(value,proto.eshop.Juridical.deserializeBinaryFromReader);
      msg.setDntSendToThirdParties(value);
      break;
    case 89:
      var value = /** @type {string} */ (reader.readString());
      msg.setCookiePolicy(value);
      break;
    case 90:
      var value = /** @type {string} */ (reader.readString());
      msg.setBasketLink(value);
      break;
    case 99:
      var value = new proto.eshop.OrderInfo;
      reader.readMessage(value,proto.eshop.OrderInfo.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 101:
      var value = new proto.eshop.SalesContacts;
      reader.readMessage(value,proto.eshop.SalesContacts.deserializeBinaryFromReader);
      msg.setSalesContacts(value);
      break;
    case 155:
      var value = /** @type {string} */ (reader.readString());
      msg.setDsUserToken(value);
      break;
    case 202:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPromocodesEnabled(value);
      break;
    case 213:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeliveryEnabled(value);
      break;
    case 219:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProductCounterEnabled(value);
      break;
    case 224:
      var value = /** @type {!Array<!proto.eshop.SurveyField>} */ (reader.readPackedEnum());
      msg.setSurveyFieldsEnabledList(value);
      break;
    case 235:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCommentFieldEnabled(value);
      break;
    case 315:
      var value = /** @type {string} */ (reader.readString());
      msg.addLandingScripts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.EShopConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.EShopConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.EShopConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.EShopConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSaleRegion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLang();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getApiUrl();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getVat();
  if (f !== 0.0) {
    writer.writeFloat(
      62,
      f
    );
  }
  f = message.getPaymentOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      64,
      f,
      proto.eshop.PaymentOption.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      65,
      f,
      proto.eshop.DeliveryOption.serializeBinaryToWriter
    );
  }
  f = message.getPrivacyPolicy();
  if (f != null) {
    writer.writeMessage(
      70,
      f,
      proto.eshop.Juridical.serializeBinaryToWriter
    );
  }
  f = message.getAcceptMarketingMessages();
  if (f != null) {
    writer.writeMessage(
      80,
      f,
      proto.eshop.Juridical.serializeBinaryToWriter
    );
  }
  f = message.getDntSendToThirdParties();
  if (f != null) {
    writer.writeMessage(
      82,
      f,
      proto.eshop.Juridical.serializeBinaryToWriter
    );
  }
  f = message.getCookiePolicy();
  if (f.length > 0) {
    writer.writeString(
      89,
      f
    );
  }
  f = message.getBasketLink();
  if (f.length > 0) {
    writer.writeString(
      90,
      f
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      99,
      f,
      proto.eshop.OrderInfo.serializeBinaryToWriter
    );
  }
  f = message.getSalesContacts();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.eshop.SalesContacts.serializeBinaryToWriter
    );
  }
  f = message.getDsUserToken();
  if (f.length > 0) {
    writer.writeString(
      155,
      f
    );
  }
  f = message.getPromocodesEnabled();
  if (f) {
    writer.writeBool(
      202,
      f
    );
  }
  f = message.getDeliveryEnabled();
  if (f) {
    writer.writeBool(
      213,
      f
    );
  }
  f = message.getProductCounterEnabled();
  if (f) {
    writer.writeBool(
      219,
      f
    );
  }
  f = message.getSurveyFieldsEnabledList();
  if (f.length > 0) {
    writer.writePackedEnum(
      224,
      f
    );
  }
  f = message.getCommentFieldEnabled();
  if (f) {
    writer.writeBool(
      235,
      f
    );
  }
  f = message.getLandingScriptsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      315,
      f
    );
  }
};


/**
 * optional string sale_region = 10;
 * @return {string}
 */
proto.eshop.EShopConfig.prototype.getSaleRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setSaleRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional Lang lang = 20;
 * @return {!proto.eshop.Lang}
 */
proto.eshop.EShopConfig.prototype.getLang = function() {
  return /** @type {!proto.eshop.Lang} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.eshop.Lang} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setLang = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional string api_url = 50;
 * @return {string}
 */
proto.eshop.EShopConfig.prototype.getApiUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setApiUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional string currency = 60;
 * @return {string}
 */
proto.eshop.EShopConfig.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional float vat = 62;
 * @return {number}
 */
proto.eshop.EShopConfig.prototype.getVat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 62, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setVat = function(value) {
  return jspb.Message.setProto3FloatField(this, 62, value);
};


/**
 * repeated PaymentOption payment_options = 64;
 * @return {!Array<!proto.eshop.PaymentOption>}
 */
proto.eshop.EShopConfig.prototype.getPaymentOptionsList = function() {
  return /** @type{!Array<!proto.eshop.PaymentOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eshop.PaymentOption, 64));
};


/**
 * @param {!Array<!proto.eshop.PaymentOption>} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setPaymentOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 64, value);
};


/**
 * @param {!proto.eshop.PaymentOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eshop.PaymentOption}
 */
proto.eshop.EShopConfig.prototype.addPaymentOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 64, opt_value, proto.eshop.PaymentOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearPaymentOptionsList = function() {
  return this.setPaymentOptionsList([]);
};


/**
 * repeated DeliveryOption delivery_options = 65;
 * @return {!Array<!proto.eshop.DeliveryOption>}
 */
proto.eshop.EShopConfig.prototype.getDeliveryOptionsList = function() {
  return /** @type{!Array<!proto.eshop.DeliveryOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eshop.DeliveryOption, 65));
};


/**
 * @param {!Array<!proto.eshop.DeliveryOption>} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setDeliveryOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 65, value);
};


/**
 * @param {!proto.eshop.DeliveryOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eshop.DeliveryOption}
 */
proto.eshop.EShopConfig.prototype.addDeliveryOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 65, opt_value, proto.eshop.DeliveryOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearDeliveryOptionsList = function() {
  return this.setDeliveryOptionsList([]);
};


/**
 * optional Juridical privacy_policy = 70;
 * @return {?proto.eshop.Juridical}
 */
proto.eshop.EShopConfig.prototype.getPrivacyPolicy = function() {
  return /** @type{?proto.eshop.Juridical} */ (
    jspb.Message.getWrapperField(this, proto.eshop.Juridical, 70));
};


/**
 * @param {?proto.eshop.Juridical|undefined} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setPrivacyPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 70, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearPrivacyPolicy = function() {
  return this.setPrivacyPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.hasPrivacyPolicy = function() {
  return jspb.Message.getField(this, 70) != null;
};


/**
 * optional Juridical accept_marketing_messages = 80;
 * @return {?proto.eshop.Juridical}
 */
proto.eshop.EShopConfig.prototype.getAcceptMarketingMessages = function() {
  return /** @type{?proto.eshop.Juridical} */ (
    jspb.Message.getWrapperField(this, proto.eshop.Juridical, 80));
};


/**
 * @param {?proto.eshop.Juridical|undefined} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setAcceptMarketingMessages = function(value) {
  return jspb.Message.setWrapperField(this, 80, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearAcceptMarketingMessages = function() {
  return this.setAcceptMarketingMessages(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.hasAcceptMarketingMessages = function() {
  return jspb.Message.getField(this, 80) != null;
};


/**
 * optional Juridical dnt_send_to_third_parties = 82;
 * @return {?proto.eshop.Juridical}
 */
proto.eshop.EShopConfig.prototype.getDntSendToThirdParties = function() {
  return /** @type{?proto.eshop.Juridical} */ (
    jspb.Message.getWrapperField(this, proto.eshop.Juridical, 82));
};


/**
 * @param {?proto.eshop.Juridical|undefined} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setDntSendToThirdParties = function(value) {
  return jspb.Message.setWrapperField(this, 82, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearDntSendToThirdParties = function() {
  return this.setDntSendToThirdParties(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.hasDntSendToThirdParties = function() {
  return jspb.Message.getField(this, 82) != null;
};


/**
 * optional string cookie_policy = 89;
 * @return {string}
 */
proto.eshop.EShopConfig.prototype.getCookiePolicy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 89, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setCookiePolicy = function(value) {
  return jspb.Message.setProto3StringField(this, 89, value);
};


/**
 * optional string basket_link = 90;
 * @return {string}
 */
proto.eshop.EShopConfig.prototype.getBasketLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 90, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setBasketLink = function(value) {
  return jspb.Message.setProto3StringField(this, 90, value);
};


/**
 * optional OrderInfo order = 99;
 * @return {?proto.eshop.OrderInfo}
 */
proto.eshop.EShopConfig.prototype.getOrder = function() {
  return /** @type{?proto.eshop.OrderInfo} */ (
    jspb.Message.getWrapperField(this, proto.eshop.OrderInfo, 99));
};


/**
 * @param {?proto.eshop.OrderInfo|undefined} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 99, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 99) != null;
};


/**
 * optional SalesContacts sales_contacts = 101;
 * @return {?proto.eshop.SalesContacts}
 */
proto.eshop.EShopConfig.prototype.getSalesContacts = function() {
  return /** @type{?proto.eshop.SalesContacts} */ (
    jspb.Message.getWrapperField(this, proto.eshop.SalesContacts, 101));
};


/**
 * @param {?proto.eshop.SalesContacts|undefined} value
 * @return {!proto.eshop.EShopConfig} returns this
*/
proto.eshop.EShopConfig.prototype.setSalesContacts = function(value) {
  return jspb.Message.setWrapperField(this, 101, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearSalesContacts = function() {
  return this.setSalesContacts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.hasSalesContacts = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional string ds_user_token = 155;
 * @return {string}
 */
proto.eshop.EShopConfig.prototype.getDsUserToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 155, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setDsUserToken = function(value) {
  return jspb.Message.setProto3StringField(this, 155, value);
};


/**
 * optional bool promocodes_enabled = 202;
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.getPromocodesEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 202, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setPromocodesEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 202, value);
};


/**
 * optional bool delivery_enabled = 213;
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.getDeliveryEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 213, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setDeliveryEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 213, value);
};


/**
 * optional bool product_counter_enabled = 219;
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.getProductCounterEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 219, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setProductCounterEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 219, value);
};


/**
 * repeated SurveyField survey_fields_enabled = 224;
 * @return {!Array<!proto.eshop.SurveyField>}
 */
proto.eshop.EShopConfig.prototype.getSurveyFieldsEnabledList = function() {
  return /** @type {!Array<!proto.eshop.SurveyField>} */ (jspb.Message.getRepeatedField(this, 224));
};


/**
 * @param {!Array<!proto.eshop.SurveyField>} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setSurveyFieldsEnabledList = function(value) {
  return jspb.Message.setField(this, 224, value || []);
};


/**
 * @param {!proto.eshop.SurveyField} value
 * @param {number=} opt_index
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.addSurveyFieldsEnabled = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 224, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearSurveyFieldsEnabledList = function() {
  return this.setSurveyFieldsEnabledList([]);
};


/**
 * optional bool comment_field_enabled = 235;
 * @return {boolean}
 */
proto.eshop.EShopConfig.prototype.getCommentFieldEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 235, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setCommentFieldEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 235, value);
};


/**
 * repeated string landing_scripts = 315;
 * @return {!Array<string>}
 */
proto.eshop.EShopConfig.prototype.getLandingScriptsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 315));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.setLandingScriptsList = function(value) {
  return jspb.Message.setField(this, 315, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.addLandingScripts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 315, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.EShopConfig} returns this
 */
proto.eshop.EShopConfig.prototype.clearLandingScriptsList = function() {
  return this.setLandingScriptsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ValidateEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ValidateEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ValidateEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ValidateEmailRequest}
 */
proto.eshop.ValidateEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ValidateEmailRequest;
  return proto.eshop.ValidateEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ValidateEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ValidateEmailRequest}
 */
proto.eshop.ValidateEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ValidateEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ValidateEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ValidateEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.eshop.ValidateEmailRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ValidateEmailRequest} returns this
 */
proto.eshop.ValidateEmailRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ValidateEmailReply.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ValidateEmailReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ValidateEmailReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateEmailReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ValidateEmailReply}
 */
proto.eshop.ValidateEmailReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ValidateEmailReply;
  return proto.eshop.ValidateEmailReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ValidateEmailReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ValidateEmailReply}
 */
proto.eshop.ValidateEmailReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ValidateEmailReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ValidateEmailReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ValidateEmailReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateEmailReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.eshop.ValidateEmailReply.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eshop.ValidateEmailReply} returns this
 */
proto.eshop.ValidateEmailReply.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ValidateDiscountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ValidateDiscountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ValidateDiscountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateDiscountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    saleRegion: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ValidateDiscountRequest}
 */
proto.eshop.ValidateDiscountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ValidateDiscountRequest;
  return proto.eshop.ValidateDiscountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ValidateDiscountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ValidateDiscountRequest}
 */
proto.eshop.ValidateDiscountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ValidateDiscountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ValidateDiscountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ValidateDiscountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateDiscountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSaleRegion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string sale_region = 1;
 * @return {string}
 */
proto.eshop.ValidateDiscountRequest.prototype.getSaleRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ValidateDiscountRequest} returns this
 */
proto.eshop.ValidateDiscountRequest.prototype.setSaleRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.eshop.ValidateDiscountRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.ValidateDiscountRequest} returns this
 */
proto.eshop.ValidateDiscountRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eshop.Discount.repeatedFields_ = [97];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eshop.Discount.oneofGroups_ = [[56,65]];

/**
 * @enum {number}
 */
proto.eshop.Discount.ValueCase = {
  VALUE_NOT_SET: 0,
  PERCENT: 56,
  AMOUNT: 65
};

/**
 * @return {proto.eshop.Discount.ValueCase}
 */
proto.eshop.Discount.prototype.getValueCase = function() {
  return /** @type {proto.eshop.Discount.ValueCase} */(jspb.Message.computeOneofCase(this, proto.eshop.Discount.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.Discount.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.Discount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.Discount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.Discount.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 10, ""),
    target: jspb.Message.getFieldWithDefault(msg, 17, 0),
    percent: jspb.Message.getFloatingPointFieldWithDefault(msg, 56, 0.0),
    amount: jspb.Message.getFieldWithDefault(msg, 65, 0),
    productIdsList: (f = jspb.Message.getRepeatedField(msg, 97)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.Discount}
 */
proto.eshop.Discount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.Discount;
  return proto.eshop.Discount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.Discount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.Discount}
 */
proto.eshop.Discount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 17:
      var value = /** @type {!proto.eshop.Discount.Target} */ (reader.readEnum());
      msg.setTarget(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPercent(value);
      break;
    case 65:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 97:
      var value = /** @type {string} */ (reader.readString());
      msg.addProductIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.Discount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.Discount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.Discount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.Discount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTarget();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 56));
  if (f != null) {
    writer.writeFloat(
      56,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 65));
  if (f != null) {
    writer.writeInt32(
      65,
      f
    );
  }
  f = message.getProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      97,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.eshop.Discount.Target = {
  NONE: 0,
  WHOLE_BASKET: 1,
  PRODUCTS_ONLY: 2,
  DELIVERY_ONLY: 3,
  PRODUCTS_LIST: 4
};

/**
 * optional string code = 10;
 * @return {string}
 */
proto.eshop.Discount.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional Target target = 17;
 * @return {!proto.eshop.Discount.Target}
 */
proto.eshop.Discount.prototype.getTarget = function() {
  return /** @type {!proto.eshop.Discount.Target} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.eshop.Discount.Target} value
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.setTarget = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional float percent = 56;
 * @return {number}
 */
proto.eshop.Discount.prototype.getPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 56, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.setPercent = function(value) {
  return jspb.Message.setOneofField(this, 56, proto.eshop.Discount.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.clearPercent = function() {
  return jspb.Message.setOneofField(this, 56, proto.eshop.Discount.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.Discount.prototype.hasPercent = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional int32 amount = 65;
 * @return {number}
 */
proto.eshop.Discount.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {number} value
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.setAmount = function(value) {
  return jspb.Message.setOneofField(this, 65, proto.eshop.Discount.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.clearAmount = function() {
  return jspb.Message.setOneofField(this, 65, proto.eshop.Discount.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.Discount.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * repeated string product_ids = 97;
 * @return {!Array<string>}
 */
proto.eshop.Discount.prototype.getProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 97));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.setProductIdsList = function(value) {
  return jspb.Message.setField(this, 97, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.addProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 97, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eshop.Discount} returns this
 */
proto.eshop.Discount.prototype.clearProductIdsList = function() {
  return this.setProductIdsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eshop.ValidateDiscountReply.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.eshop.ValidateDiscountReply.ResultCase = {
  RESULT_NOT_SET: 0,
  OK: 1,
  ERROR: 2
};

/**
 * @return {proto.eshop.ValidateDiscountReply.ResultCase}
 */
proto.eshop.ValidateDiscountReply.prototype.getResultCase = function() {
  return /** @type {proto.eshop.ValidateDiscountReply.ResultCase} */(jspb.Message.computeOneofCase(this, proto.eshop.ValidateDiscountReply.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eshop.ValidateDiscountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.eshop.ValidateDiscountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eshop.ValidateDiscountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateDiscountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    ok: (f = msg.getOk()) && proto.eshop.Discount.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.eshop.BasketError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eshop.ValidateDiscountReply}
 */
proto.eshop.ValidateDiscountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eshop.ValidateDiscountReply;
  return proto.eshop.ValidateDiscountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eshop.ValidateDiscountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eshop.ValidateDiscountReply}
 */
proto.eshop.ValidateDiscountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eshop.Discount;
      reader.readMessage(value,proto.eshop.Discount.deserializeBinaryFromReader);
      msg.setOk(value);
      break;
    case 2:
      var value = new proto.eshop.BasketError;
      reader.readMessage(value,proto.eshop.BasketError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eshop.ValidateDiscountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eshop.ValidateDiscountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eshop.ValidateDiscountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eshop.ValidateDiscountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOk();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.eshop.Discount.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.eshop.BasketError.serializeBinaryToWriter
    );
  }
};


/**
 * optional Discount ok = 1;
 * @return {?proto.eshop.Discount}
 */
proto.eshop.ValidateDiscountReply.prototype.getOk = function() {
  return /** @type{?proto.eshop.Discount} */ (
    jspb.Message.getWrapperField(this, proto.eshop.Discount, 1));
};


/**
 * @param {?proto.eshop.Discount|undefined} value
 * @return {!proto.eshop.ValidateDiscountReply} returns this
*/
proto.eshop.ValidateDiscountReply.prototype.setOk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.eshop.ValidateDiscountReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.ValidateDiscountReply} returns this
 */
proto.eshop.ValidateDiscountReply.prototype.clearOk = function() {
  return this.setOk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.ValidateDiscountReply.prototype.hasOk = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BasketError error = 2;
 * @return {?proto.eshop.BasketError}
 */
proto.eshop.ValidateDiscountReply.prototype.getError = function() {
  return /** @type{?proto.eshop.BasketError} */ (
    jspb.Message.getWrapperField(this, proto.eshop.BasketError, 2));
};


/**
 * @param {?proto.eshop.BasketError|undefined} value
 * @return {!proto.eshop.ValidateDiscountReply} returns this
*/
proto.eshop.ValidateDiscountReply.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.eshop.ValidateDiscountReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eshop.ValidateDiscountReply} returns this
 */
proto.eshop.ValidateDiscountReply.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eshop.ValidateDiscountReply.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.eshop.PaymentGateway = {
  NO_PAYMENT_GATEWAY: 0,
  CASH_TO_THE_COURIER: 10,
  PAYU: 11,
  CSOB: 12,
  MONETA: 14
};

/**
 * @enum {number}
 */
proto.eshop.SurveyField = {
  NO_SURVEY_FIELD: 0,
  FIO: 1,
  MAIL: 2,
  PHONE: 3,
  POSTCODE: 4,
  CITY: 5,
  ADDRESS: 6,
  ACM: 7,
  DNTSNDTO3RDPRT: 8
};

/**
 * @enum {number}
 */
proto.eshop.DeliveryType = {
  NO_DELIVERY_TYPE: 0,
  COURIER: 1,
  PICKUP: 2
};

/**
 * @enum {number}
 */
proto.eshop.PaymentState = {
  NO_ORDER_STATE: 0,
  INITIATED: 11,
  IN_PROGRESS: 21,
  WAITING_FOR_SETTLEMENT: 31,
  CONFIRMED: 41,
  CANCELLED: 51,
  DENIED: 61,
  REFUND_REQUEST: 71,
  REFUND_PROCESSING: 81,
  RETURNED: 91,
  REVERSED: 101,
  SETTLED: 121
};

/**
 * @enum {number}
 */
proto.eshop.Lang = {
  NO_LANG: 0,
  RU: 1,
  EN: 2,
  UK: 3,
  CS: 4,
  SK: 5,
  PL: 6
};

/**
 * @enum {number}
 */
proto.eshop.SalesContactType = {
  NO_CONTACT_TYPE: 0,
  TEL: 1,
  EMAIL: 2
};

goog.object.extend(exports, proto.eshop);
